<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Assign via Project</h4>
      <p>Assign blueprints to one project</p>
    </div>
    <div class="action-container">
      <button type="button"
              class="btn btn-primary"
              [disabled]="!canAssign"
              (click)="onAssignBlueprints()"
              data-test="AssignBlueprint">
        Assign
      </button>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main">
    <div class="top-panel" style="width: 100%; display: flex; gap: 12px;">
      <ng-select name="Project"
                 style="flex: 1"
                 bindLabel="Label"
                 [(ngModel)]="selectedProject"
                 (ngModelChange)="onProjectChanged()"
                 placeholder="Select a project"
                 [items]="projects"
                 groupBy="ProjectStatus"
                 required
                 data-test="AssignBlueprintsToOneProject">
      </ng-select>
    </div>

    <div>
      <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
      <ag-grid-angular #agGrid
                       id="ViewGrid"
                       style="width: 100%; height: 540px"
                       class="ag-theme-balham"
                       [gridOptions]="gridOptions"
                       [rowData]="rowData"
                       [pagination]="true"
                       (gridReady)="onGridReady($event)"
                       (selectionChanged)="onSelectionChanged($event)">
      </ag-grid-angular>
    </div>
  </div>
</div>